(function () {

  'use strict';

  function pxWorkstationSettings(
    NetworkListPaging, NetworkListService, toastr, $filter, EventServiceEvents, Utils,
    WorkstationListService, $routeParams, URL_PARAMS, $ngBootbox, SnmpConfigurationService,
    SUPPORTED_OS, $timeout, $rootScope, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        workstation: '=workstation',
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/workstationSettings.template.html',
      link: function (scope) {

        scope.networkListPaging = new NetworkListPaging();
        scope.workstationAdapterList = [];
        scope.workstationOriginal = angular.copy(scope.workstation);
        scope.selectedSnmpConfig = null;
        scope.supportedOs = SUPPORTED_OS;
        scope.networkIds = null;

        (function () {
          mapGatewayAdapter();
          getDefaultSnmpConfiguration();
          setListeners();
        })();

        function getDefaultSnmpConfiguration() {
          SnmpConfigurationService.getDefaultSnmpConfiguration().then(function (defaultSnmpConfiguration) {
            scope.selectedSnmpConfig = defaultSnmpConfiguration;
          }).catch(function(error){});
        }

        scope.openSnmpConfigurationSelector = function () {
          scope.snmpConfigurationSelectorIsOpen = true;
        };

        scope.selectSnmpConfiguration = function (snmpConfiguration) {
          scope.snmpConfigurationSelectorIsOpen = false;
          if (snmpConfiguration) {
            scope.selectedSnmpConfig = snmpConfiguration;
          }
        };

        function mapGatewayAdapter() {
          scope.workstationAdapterList = [];
          scope.workstationVirtualAdapterList = [];
          angular.forEach(scope.workstation.info._embedded.adapters, function (adapter) {
            const adapterMapped = {
              ip: adapter.gateway.ip,
              mac: adapter.gateway.mac,
              virtual: adapter.virtual,
              networkName: getNetworkName(adapter),
              networkMatch: checkAdaptersOnNetworks(adapter),
              networkId: adapter._links['px:network'] ? networkUUID(adapter._links['px:network'].href) : null,
              _links: adapter._links
            };
            if (!adapter.virtual) {
              scope.workstationAdapterList.push(adapterMapped);
            } else {
              scope.workstationVirtualAdapterList.push(adapterMapped);
            }
          });
          scope.networkIds = scope.workstationAdapterList.length ? scope.workstationAdapterList.map(adapter => adapter.networkId) : null;
        }

        function networkUUID(link) {
          let networkUUID = link.split('/');
          networkUUID = networkUUID[networkUUID.length - 1];
          return networkUUID;
        }

        function getNetworkName(adapter) {
          let networkName = null;
          const networksData = scope.workstation.info._embedded;
          if (!networksData.networks) {
            return networkName;
          } else {
            for (let i = 0; i < networksData.networks.length; i++) {
              for (let j = 0; j < networksData.networks[i].gateways.length; j++) {
                if ((adapter.gateway.mac.toUpperCase() === networksData.networks[i].gateways[j].mac.toUpperCase() || networksData.networks[i].gateways[j].mac === '*') && adapter.gateway.ip  === networksData.networks[i].gateways[j].ip) {
                  networkName = networksData.networks[i].name;
                  break;
                }
              }
            }
          }

          return networkName;
        }

        function checkAdaptersOnNetworks(adapter) {
          let matchForGateWay = false;
          const networks = scope.workstation.info._embedded.networks;
          if (!networks) {
            return matchForGateWay;
          } else {
            for (let i = 0; i < networks.length; i++) {
              for (let j = 0; j < networks[i].gateways.length; j++) {
                if ((adapter.gateway.mac.toUpperCase() === networks[i].gateways[j].mac.toUpperCase() || networks[i].gateways[j].mac === '*') && adapter.gateway.ip === networks[i].gateways[j].ip) {
                  matchForGateWay = true;
                  break;
                }
              }
            }
          }

          return matchForGateWay;
        }

        scope.toggleScanGatewayOption = function (scanGatewayState) {
          scope.workstationOriginal.saveChanges(scope.workstation).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){});
        };

        scope.toggleGatewayOption = function (printGatewayState) {
          scope.workstation.info.printGateway = printGatewayState;
          scope.workstationOriginal.saveChanges(scope.workstation).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){});
        };

        scope.toggleHasStaticIPOption = function (hasStaticIpState) {
          scope.workstationOriginal.saveChanges(scope.workstation).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){});
        };

        scope.toggleOnBehalfOfOption = function (onBehalfOfState) {
          scope.workstation.info.onBehalfOf = onBehalfOfState;
          scope.workstationOriginal.saveChanges(scope.workstation).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){});
        };

        scope.toggleVirtualNetworkAccess = function (virtualNetworkAccess) {
          scope.workstation.info.virtualNetworkAccess = virtualNetworkAccess;
          scope.workstationOriginal.saveChanges(scope.workstation).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){});
        };

        scope.startDiscovery = function () {
          $ngBootbox.confirm($filter('translate')('StartDiscoveryQuestion')).then(function () {
            scope.tenant.discoverEnvironment(scope.workstationOriginal, scope.selectedSnmpConfig).then(function () {
              toastr.success($filter('translate')('DiscoveryStarted'));
            }).catch(function(error){});
          }).catch(function(error){});
        };

        scope.openAddUnknownNetworkDialog = function (event, adapter) {
          event.stopPropagation();
          scope.clearPopups();
          scope.networkListPaging.pagingCriteria.pageSize = 5;
          scope.networkListPaging.pagingCriteria.match = null;
          scope.networkSelectConfiguration = {
            paginationObject: scope.networkListPaging,
            placeholderText: 'Search',
            service: 'NetworkListService',
            contentHeight: 463,
            adapterID: adapter._links.self.href
          };
          scope.networkSelectPopupObject = {
            dimensions: { height: 463, width: 400 },
            offset: { top: 32, left: 230 },
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            context: 'selectNetwork',
            type: 'PAGINATION',
            title: 'SelectNetwork',
            confirmText: 'SelectNetwork',
            clickOutsideToClose: true
          };
        };

        scope.openCreateNetworkDialog = function (event, adapter) {
          event.stopPropagation();
          scope.clearPopups();
          scope.networkListPaging.pagingCriteria.pageSize = 5;
          scope.networkListPaging.pagingCriteria.match = null;
          scope.createNetworkConfiguration = {
            adapterID: adapter._links.self.href,
            inputDataObject: [
              {
                label: 'NetworkName',
                placeholder: 'NetworkName',
                type: 'input',
                keyIdentifier: 'name',
                value: null,
                focus: true,
                allowEmptyInput: false,
                regex: null
              }
            ]
          };
          scope.createNetworkPopupObject = {
            dimensions: { height: 175, width: 400 },
            offset: { top: 32, left: 230 },
            pointerPosition: 'right',
            relativePosition: 'over',
            absoluteX: event.clientX,
            absoluteY: event.clientY,
            context: 'addNewNetwork',
            type: 'SIMPLE_INPUT',
            title: 'AddNewNetwork',
            confirmText: 'AddNewNetwork',
            clickOutsideToClose: true
          };
        };

        scope.clearPopups = function () {
          scope.networkSelectConfiguration = null;
          scope.networkPopupObject = null;

          scope.createNetworkConfiguration = null;
          scope.createNetworkPopupObject = null;
        };

        scope.addUknownNetworkToNetwork = function (network, adapter) {
          const objectToSend = {
            ip: adapter.ip,
            mac: adapter.mac
          };
          network.addGateway(objectToSend, true).then(function (response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
        };

        scope.createNetworkWithAdapters = function (networkName, adapter) {
          const adapters = [{
            ip: adapter.ip,
            mac: adapter.mac
          }];

          NetworkListService.addNetworkWithAdapters(networkName.value, adapters).then(function () {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'));
          });
        };

        function refreshWorkstation() {
          WorkstationListService.getWorkstationById($routeParams[URL_PARAMS.WORKSTATION_ID.ROUTE]).then(function (workstation) {
            scope.workstation = angular.copy(workstation);
            if (!workstation.info.printGateway) {
              scope.workstation.info.printGateway = false;
            }
            scope.workstationOriginal = angular.copy(workstation);
            mapGatewayAdapter();
          }).catch(function(error){});
        }

        /// ////////////////////////////////////
        /// /// TOOLTIPS
        /// ////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'site':
                siteTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function siteTooltip(position, title) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: title,
            type: 'statement'
          };
          scope.tooltipObject = {
            position: { left: position.startX, top: position.startY + 20 }
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        /// ////////////////////////////////////
        /// /// NEW CONTEXT MENUS
        /// ////////////////////////////////////
        scope.openContextMenu = function (event, context, menuOption) {
          $timeout(function  () {
            if (event && menuOption) {
              scope.selectedContextMenuItem  =  menuOption;
              scope.contextPosition = { left: event.clientX, top: event.clientY };
              scope.context = context;
              scope.resource = scope.tenant;
            }
          }, 50);
        };

        scope.closeAllMenues = function (newContext) {

          if (newContext) {
            openNewContext(newContext);
          } else {
            scope.selectedContextMenuItem  =  null;
            scope.contextPosition = null;
            scope.context = null;
          }
        };

        function openNewContext(newContext) {
          scope.openContextMenu(newContext.event, newContext, { type: newContext.type, title: newContext.title });
        }

        /// /////////////////////////////////
        /// /////////////////////////////////
        /// ///  Open context menu
        /// /////////////////////////////////
        scope.openListMenu = function (event, context) {

          let menuItems = null;
          let icon = null;
          switch (context.type) {
            case 'networkMenu':
              menuItems = [
                // {title: 'Networks', selected: false, type: 'showWorkstationNetworks', breaker: true},
                { title: 'AddNewNetwork', selected: false, type: 'createNetwork', breaker: false, disabled: scope.me.isSystemObserver() && !scope.isThisResourceMine },
                { title: 'AddToNetwork', selected: false, type: 'addToNetwork', breaker: false, disabled: scope.me.isSystemObserver() && !scope.isThisResourceMine }
                // {title: 'RemoveFromNetwork', selected: false, type: 'removeSecureGroups', breaker: true },
              ];
              icon = 'icon-correct-network';
              break;
          }

          context.name = $filter('translate')(context.name);

          scope.closeAllMenues();

          $timeout(function () {
            scope.menuContent = {
              menuItems: menuItems,
              context: context,
              icon: icon,
              sizeClass: 'size115',
              type: 'ALLROUND'
            };
            scope.menuSpecs = {
              position: { left: event.clientX, top: event.clientY },
              type: 'ALLROUND'
            };
          }, 50);
        };

        scope.closeMenu = function (selection, position, content) {
          if (selection) {
            scope.openContextMenu({ clientX: position.left, clientY: position.top }, content.context, selection);
          }
          scope.menuContent = null;
          scope.menuSpecs = null;
          scope.contextContent = null;
        };

        scope.removeGatewayAdapter = function (event, adapter) {
          scope.closeMenu();
          $timeout(function () {
            scope.contextContent = {
              workstation: scope.workstation,
              tenant: scope.tenant,
              adapter: adapter
            };
            scope.menuContent = {
              menuItem: { title: 'RemoveAdapter', selected: false, type: 'removeAdapter' }
            };

          }, 50);
        };

        scope.testComputerConnection = function () {
          const url = scope.workstation.info._links['px:testConnection'].href;
          $http.post(url).then(function (response) {
            const activeBool = (response.data.toLowerCase() === 'true');
            if (scope.workstation.info.active !== activeBool) {
              scope.callback();
            }
            toastr.success($filter('translate')('TestSuccessfull'));
          }).catch(function(error){
            toastr.error($filter('translate')('error'));
          });
        };

        function setListeners() {

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.WORKSTATION_NETWORK_CHANGED, function (name, data) {
            const workstatioInEvent = Utils.removeDomainFromUrl(data.workstation);
            const workstationInScope = Utils.removeDomainFromUrl(scope.workstation.info._links.self.href);

            if (workstatioInEvent === workstationInScope) {
              refreshWorkstation();
            }
          });

        }

        const relayWsUpdateListener = $rootScope.$on('RELAY_WS_UPDATE', function (name, data)   {
          const workstationInScope = Utils.removeDomainFromUrl(scope.workstation.info._links.self.href);
          if (data.workstationInEvent === workstationInScope) {
            mapGatewayAdapter();
          }
        });

        scope.$on('$destroy', function () {
          relayWsUpdateListener();
        });

      }
    };
  }

  pxWorkstationSettings.$inject = [
    'NetworkListPaging', 'NetworkListService', 'toastr', '$filter', 'EventServiceEvents', 'Utils',
    'WorkstationListService', '$routeParams', 'URL_PARAMS', '$ngBootbox', 'SnmpConfigurationService',
    'SUPPORTED_OS', '$timeout', '$rootScope', '$http'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkstationSettings', pxWorkstationSettings);

})();
